import * as React from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Text,
  TogglerCheckbox,
} from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import CheckboxInput from './CheckboxInput'
import MinutesInput from './MinutesInput'
import type ToleranceSettingForm from './form'

export interface Props {
  form: ToleranceSettingForm
  onSubmit: () => void
  showEffectiveAtModal: () => void
}

const WorkedHours = ({ form, onSubmit, showEffectiveAtModal }: Props) => {
  const onChange = () => {
    form.get('workedHoursToleranceEnabled').set(!form.get('workedHoursToleranceEnabled').value)
    !form.isNewRecord && disableTolerance() && onSubmit()
  }

  const disableTolerance = () => {
    return !form.get('workedHoursToleranceEnabled').value
  }

  const isDirty = form.workedHoursIsDirty
  const workedHoursDataMandatory = form.workedHoursIsNull

  return (
    <Box aria-label="attendance-tolerance-setting-form-worked-hours">
      <CollapsableCard
        open={Boolean(form.get('workedHoursToleranceEnabled').value)}
        Card={
          <Box gap="s8">
            <Box flexDirection="row" justifyContent="spaceBetween">
              <Text.Normal weight="medium">
                {i18n.t('time_tracking.settings.tolerance_settings.worked_hours.title')}
              </Text.Normal>
              <TogglerCheckbox
                value={form.get('workedHoursToleranceEnabled').value}
                onChange={onChange}
                labelBefore
              />
            </Box>
            <Box paddingRight="s64">
              <Text.Normal color="grey800">
                {i18n.t('time_tracking.settings.tolerance_settings.worked_hours.description')}
              </Text.Normal>
            </Box>
          </Box>
        }
        Content={
          <Box gap="s12">
            <Box gap="s8">
              <Text.Normal weight="medium">
                {i18n.t('time_tracking.settings.tolerance_settings.worked_hours.worked_range')}
              </Text.Normal>
              <Box
                flexDirection="row"
                alignItems="center"
                justifyContent="spaceBetween"
                width="full"
                gap="s12"
              >
                <MinutesInput
                  label={i18n.t('time_tracking.settings.tolerance_settings.worked_hours.below')}
                  minutesFormField={form.get('belowEstimated')}
                  mandatory={workedHoursDataMandatory}
                />
                <Box paddingTop="s24">
                  <Text.Normal color="grey600">–</Text.Normal>
                </Box>
                <MinutesInput
                  label={i18n.t('time_tracking.settings.tolerance_settings.worked_hours.above')}
                  minutesFormField={form.get('aboveEstimated')}
                  mandatory={workedHoursDataMandatory}
                />
              </Box>
            </Box>
            <CheckboxInput
              field={form.get('workedHoursRoundingEnabled')}
              label={i18n.t('time_tracking.settings.tolerance_settings.worked_hours.round')}
            />
            {isDirty && (
              <Box alignItems="flexEnd">
                <Button onClick={() => showEffectiveAtModal()}>{i18n.t('common.submit')}</Button>
              </Box>
            )}
          </Box>
        }
      />
    </Box>
  )
}

export default observer(WorkedHours)
